import React from "react";
import "./faqItem.css";
import v4 from "uuid";
import classNames from "classnames";
import { highlightedString } from "../../helperFunctions/parseSearch";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

class FaqItem extends React.Component {
  constructor(props) {
    super(props);
    const { searchFaqText, faq } = props;
    const hasMatch = this.checkForMatch(faq, searchFaqText);
    this.state = {
      open: hasMatch,
    };
  }

  FAQ = React.createRef();

  // Normalize escaped markdown so ReactMarkdown can render correctly
  sanitizeMd = (s) => {
    if (!s) return "";
    let t = s;
    // Decode common escape sequences
    t = t.replace(/\\n/g, "\n");
    t = t.replace(/\\"/g, '"').replace(/\\'/g, "'");
    // Remove backslashes before markdown punctuation
    t = t.replace(/\\([*_{}\[\]()#+\-.!>])/g, "$1");
    return t;
  };

  checkForMatch = (faq, searchText) => {
    if (!searchText || searchText.length <= 2) {
      return false;
    }
    const regex = new RegExp(
      searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"),
      "i"
    );
    const questionText = this.sanitizeMd(faq.question || "").replace(
      /<(?:.|\n)*?>/gm,
      ""
    );
    const answerText = this.sanitizeMd(faq.answer || "").replace(
      /<(?:.|\n)*?>/gm,
      ""
    );
    return regex.test(questionText) || regex.test(answerText);
  };

  componentDidMount() {
    const { open } = this.state;
    if (open) {
      const panel = this.FAQ.current;
      if (panel) {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { searchFaqText, faq } = this.props;

    if (prevProps.searchFaqText !== searchFaqText) {
      const hasMatch = this.checkForMatch(faq, searchFaqText);
      const shouldBeOpen = hasMatch;

      if (shouldBeOpen !== this.state.open) {
        this.setState({ open: shouldBeOpen }, () => {
          const panel = this.FAQ.current;
          if (panel) {
            if (shouldBeOpen) {
              panel.style.maxHeight = panel.scrollHeight + "px";
            } else {
              panel.removeAttribute("style");
            }
          }
        });
      }
    }
  }

  toggleQuestion = () => {
    const panel = this.FAQ.current;

    if (panel && panel.style.maxHeight) {
      panel.removeAttribute("style");
    } else if (panel) {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    const { faq, searchFaqText } = this.props;
    const { open } = this.state;
    const q = this.sanitizeMd(faq.question || "");
    const a = this.sanitizeMd(faq.answer || "");
    return (
      <div className={classNames("panel-wrapper", { open: open })}>
        <button className="accordion" onClick={this.toggleQuestion} id={v4()}>
          <span>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{ p: "span", h1: "span", h2: "span", h3: "span" }}>
              {searchFaqText ? highlightedString(q, searchFaqText) : q}
            </ReactMarkdown>
          </span>
        </button>
        <div ref={this.FAQ} className={"panel faq"}>
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {searchFaqText ? highlightedString(a, searchFaqText) : a}
          </ReactMarkdown>
        </div>
      </div>
    );
  }
}

export default FaqItem;
